import { LogRecordStatus } from '@fleet-beat/core';

export const shortLinePairs: string[][] = [
  [LogRecordStatus.OffDuty, LogRecordStatus.SleeperBerth],
  [LogRecordStatus.PersonalConveyance, LogRecordStatus.SleeperBerth],

  [LogRecordStatus.SleeperBerth, LogRecordStatus.Driving],

  [LogRecordStatus.Driving, LogRecordStatus.OnDuty],
  [LogRecordStatus.Driving, LogRecordStatus.YardMove],
];

export const mediumLinePairs: string[][] = [
  [LogRecordStatus.OffDuty, LogRecordStatus.Driving],
  [LogRecordStatus.PersonalConveyance, LogRecordStatus.Driving],

  [LogRecordStatus.SleeperBerth, LogRecordStatus.OnDuty],

  [LogRecordStatus.SleeperBerth, LogRecordStatus.YardMove],
];

export const longLinePairs: string[][] = [
  [LogRecordStatus.OffDuty, LogRecordStatus.OnDuty],
  [LogRecordStatus.OffDuty, LogRecordStatus.YardMove],
  [LogRecordStatus.PersonalConveyance, LogRecordStatus.OnDuty],
  [LogRecordStatus.PersonalConveyance, LogRecordStatus.YardMove],
];
